import {
    apiRequest,
    bobotTunjanganKhususDetail, 
    bobotTunjanganKhususUpdate,
} from "../../../../../../services/adapters/master/bobotTunjanganKhususService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", bobotTunjanganKhususDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", bobotTunjanganKhususUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository